import "core-js/modules/es.array.join.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  class: "evaluate-container"
};
var _hoisted_2 = {
  class: "evaluate-body"
};
var _hoisted_3 = {
  class: "type-list"
};
var _hoisted_4 = {
  class: "eva-textarea"
};
var _hoisted_5 = {
  class: "comment-head"
};
var _hoisted_6 = {
  class: "add-comment-btn"
};
var _hoisted_7 = {
  class: "comment-list"
};
var _hoisted_8 = ["title", "onClick"];
var _hoisted_9 = {
  class: "eva-evidence"
};
var _hoisted_10 = {
  class: "file-box"
};
import { ref, computed, onMounted } from 'vue';
import { isNullValue } from '../utils';
import AddComment from './AddComment.vue';
import FileList from './FileList.vue';
export default {
  __name: 'Evaluate',
  props: {
    data: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    commentData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var props = __props;
    var activeValue = ref(-1);
    var evidence = ref([]);
    var comment = ref('');
    var showAddComment = ref(false);
    var showAddBtn = computed(function () {
      return !isNullValue(props.data);
    });

    /**
     * 上传文件
     */
    var uploadEvnt = function uploadEvnt(list) {
      evidence.value = list;
    };
    /**
     * 当前类型
     */
    var activeType = computed(function () {
      if (activeValue.value === -1) return null;
      return ['优秀', '合格', '不合格'][activeValue.value];
    });
    onMounted(function () {});

    /**
     * 点击类型
     */
    var clickActiveEvent = function clickActiveEvent(value) {
      activeValue.value = value;
    };
    /**
     * 点击评论
     */
    var handleClickComment = function handleClickComment(item) {
      var commentData = [comment.value, item === null || item === void 0 ? void 0 : item.content];
      comment.value = commentData.join('') || '';
    };
    /**
     * 关闭添加评语
     */
    var closeAddComment = function closeAddComment() {
      showAddComment.value = false;
    };

    /*
     * 添加评语
     */
    var addCommentEvent = function addCommentEvent(item) {
      handleClickComment(item);
      closeAddComment();
    };
    __expose({
      evidence: evidence,
      activeType: activeType,
      comment: comment
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_textarea = _resolveComponent("t-textarea");
      var _component_upload_file = _resolveComponent("upload-file");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(['type-item', {
          'is-active': activeValue.value === 0
        }]),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return clickActiveEvent(0);
        })
      }, [_createVNode(_component_svg_icon, {
        name: "face-excellent",
        size: "48"
      }), _cache[4] || (_cache[4] = _createElementVNode("span", null, "优秀", -1)), _createVNode(_component_svg_icon, {
        name: activeValue.value === 0 ? 'check-type-select' : 'check-type',
        class: "select-icon",
        size: "16"
      }, null, 8, ["name"])], 2), _createElementVNode("div", {
        class: _normalizeClass(['type-item', {
          'is-active': activeValue.value === 1
        }]),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return clickActiveEvent(1);
        })
      }, [_createVNode(_component_svg_icon, {
        name: "face-qualified",
        size: "48"
      }), _cache[5] || (_cache[5] = _createElementVNode("span", null, "合格", -1)), _createVNode(_component_svg_icon, {
        name: activeValue.value === 1 ? 'check-type-select' : 'check-type',
        class: "select-icon",
        size: "16"
      }, null, 8, ["name"])], 2), _createElementVNode("div", {
        class: _normalizeClass(['type-item', {
          'is-active': activeValue.value === 2
        }]),
        onClick: _cache[2] || (_cache[2] = function ($event) {
          return clickActiveEvent(2);
        })
      }, [_createVNode(_component_svg_icon, {
        name: "face-unqualified",
        size: "48"
      }), _cache[6] || (_cache[6] = _createElementVNode("span", null, "不合格", -1)), _createVNode(_component_svg_icon, {
        name: activeValue.value === 2 ? 'check-type-select' : 'check-type',
        class: "select-icon",
        size: "16"
      }, null, 8, ["name"])], 2)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[8] || (_cache[8] = _createElementVNode("span", {
        class: "head-title"
      }, "添加评语", -1)), _withDirectives(_createVNode(AddComment, {
        data: __props.data,
        onClose: closeAddComment,
        onAdd: addCommentEvent
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_6, [_createVNode(_component_svg_icon, {
            name: "reset",
            style: {
              "margin-right": "4px"
            }
          }), _cache[7] || (_cache[7] = _createElementVNode("span", null, "自定义评语设置", -1))])];
        }),
        _: 1
      }, 8, ["data"]), [[_vShow, showAddBtn.value]])]), _createVNode(_component_t_textarea, {
        value: comment.value,
        "onUpdate:value": _cache[3] || (_cache[3] = function ($event) {
          return comment.value = $event;
        }),
        placeholder: "请输入评语内容",
        name: "description"
      }, null, 8, ["value"]), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.commentData, function (commentItem) {
        return _openBlock(), _createElementBlock("div", {
          key: commentItem.id,
          class: "comment-list__item",
          title: commentItem.content,
          onClick: function onClick($event) {
            return handleClickComment(commentItem);
          }
        }, _toDisplayString(commentItem.content), 9, _hoisted_8);
      }), 128))])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[9] || (_cache[9] = _createElementVNode("span", null, "添加佐证材料", -1)), _createVNode(_component_upload_file, {
        onUpload: uploadEvnt
      })]), _createVNode(FileList, {
        value: evidence.value
      }, null, 8, ["value"])])])]);
    };
  }
};